import axios from 'axios';
import publicIp from 'public-ip';
import fetch from 'isomorphic-fetch';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import qs from 'query-string';

import {
  GET_LIVE_STREAM_DATA_REQUEST,
  GET_LIVE_STREAM_DATA_SUCCESS,
  GET_LIVE_STREAM_DATA_FAILURE,
  AUTHENTICATE_LIVE_STREAM_REQUEST,
  AUTHENTICATE_LIVE_STREAM_SUCCESS,
  AUTHENTICATE_LIVE_STREAM_FAILURE,
  AUTHENTICATE_PERFORM_LIVE_STREAM,
  RESET_LIVE_STREAM_AUTHENTICATE,

  GET_LIVE_STREAM_TABS_REQUEST,
  GET_LIVE_STREAM_TABS_SUCCESS,
  GET_LIVE_STREAM_TABS_FAILURE,

  GET_LIVE_STREAM_COUPONS_DATA_REQUEST,
  GET_LIVE_STREAM_COUPONS_DATA_SUCCESS,
  GET_LIVE_STREAM_COUPONS_DATA_FAILURE,

  SET_LIVE_STREAM_START,
  SET_LIVE_STREAM_STOP,

  SET_TJK_LIVE_STREAM_START,
  SET_TJK_LIVE_STREAM_STOP
} from 'Store/constants';

import { openModal } from 'Store/actions';

import ProjectConfig from 'ProjectConfig';
import EnvironmentManager from '../../../utils/environmentManager';
import {
  LIVE_STREAM_GEO_BLOCK_ERROR_CODE,
  createLiveStreamAuthError,
  createLiveStreamAuthFailurePayload,
  createLiveStreamGeoBlockError,
  getGeoBlockStatusCodeFromErrorResponse,
  isLiveStreamGeoBlockError,
  isLiveStreamPlayerError,
} from 'Utils/liveStreamGeoBlockHelper';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

const handleStreamAuthStatusCode = (dispatch, statusCode, statusDescription) => {
  if (statusCode === -2) {
    dispatch(openModal('liveStreamControlModal'));
    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_FAILURE,
      payload: statusCode
    });
    return true;
  }

  if (Number(statusCode) === LIVE_STREAM_GEO_BLOCK_ERROR_CODE) {
    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_FAILURE,
      payload: createLiveStreamGeoBlockError()
    });
    return true;
  }

  if (Number(statusCode) < 0) {
    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_FAILURE,
      payload: createLiveStreamAuthError(statusCode, statusDescription)
    });
    return true;
  }

  return false;
};

const getPerformLaunchUrl = launchResponse => {
  const streamLaunchers = launchResponse?.launchInfo?.streamLauncher;
  if (!Array.isArray(streamLaunchers)) {
    return null;
  }

  const httpsLauncher = streamLaunchers.find(item => typeof item?.launcherURL === 'string' && item.launcherURL.startsWith('https'));
  if (httpsLauncher?.launcherURL) {
    return httpsLauncher.launcherURL;
  }

  const fallbackLauncher = streamLaunchers.find(item => typeof item?.launcherURL === 'string');
  return fallbackLauncher?.launcherURL || null;
};

export const authenticateLiveStream = (streamId, provider, sportId) => dispatch => {
  try {
    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_REQUEST
    });
    switch (provider) {
      case 'BETRADAR':
        dispatch(authenticateBetRadarStream(streamId, sportId));
        break;
      case 'UNAS': // kullanılmıyor 03.02.2022
        dispatch(authenticateUnasStream(streamId));
        break;
      case 'IMG':
        dispatch(authenticateImgStream(streamId));
        break;
      case 'PERFORM':
        dispatch(authenticatePerformStream(streamId));
        break;
      case 'TJK':
        dispatch(authenticateTjkStream());
        break;
      case 'INFRONT':
        dispatch(authenticateInfrontStream(streamId));
        break;
    }

  } catch (error) {
    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_FAILURE,
      payload: error.response && error.response.data || {}
    });
  }
};

const authenticateTjkStream  = streamId => async dispatch => {
  const TJKTV_STREAM_URL = EnvironmentManager.getMessageText({ key: 'tjk_tv1_url' });

  try {
    const res = await axios.get('/user-settings', {
      params: { full: true }
    });

    if (res) {
      dispatch({
        type: AUTHENTICATE_LIVE_STREAM_SUCCESS,
        payload: {
          url: TJKTV_STREAM_URL,
          code: null,
          description: null,
          provider: 'TJK'
        }
      });
    }
  } catch (error) {
    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_FAILURE,
      payload: error.response?.data || {}
    });
  }
};

const authenticateBetRadarStream = (streamId, sportId) => async (dispatch, getState) => {
  try {
    let clientIp = await publicIp.v4();
    //yeni eklendi
    const externalCustomerId = getState().auth?.data?.externalCustomerId;
    // const apiUrl = `/mobile/live-stream/betradar/${streamId}/authentication?externalCustomerId=${externalCustomerId}`;
    const apiUrl = `/mobile/live-stream/betradar/${streamId}/authentication/v3?externalCustomerId=${externalCustomerId}&eventType=${sportId}`;
    const res = await axios.get(API_GATEWAY + apiUrl, { headers: { clientIp } });
    const { authenticationUrl, statusCode, statusDescription } = res.data.authenticationResult;

    if (handleStreamAuthStatusCode(dispatch, statusCode, statusDescription)) {
      return;
    }

    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_SUCCESS,
      payload: {
        url: authenticationUrl,
        code: statusCode,
        description: statusDescription,
        provider: 'BETRADAR',
        streamId: streamId
      }
    });
  } catch (error) {
    const errorData = error.response?.data;
    const errorStatusCode = getGeoBlockStatusCodeFromErrorResponse(errorData);

    if (errorStatusCode != null && errorStatusCode < 0) {
      dispatch({
        type: AUTHENTICATE_LIVE_STREAM_FAILURE,
        payload: createLiveStreamAuthFailurePayload(
          errorStatusCode,
          errorData?.authenticationResult?.statusDescription
          ?? errorData?.error?.message
          ?? errorData?.message
        )
      });
    } else {
      dispatch({
        type: AUTHENTICATE_LIVE_STREAM_FAILURE,
        payload: errorData || {}
      });
    }
  }
};

const authenticateUnasStream = streamId => async dispatch => {
  try {
    let clientIp = await publicIp.v4();
    const apiUrl = `/mobile/live-stream/unas/${streamId}/web/authentication`;
    const res = await axios.get(API_GATEWAY + apiUrl, { headers: { clientIp } });
    const { authenticationUrl, statusCode, statusDescription } = res.data.authenticationResult;

    if (handleStreamAuthStatusCode(dispatch, statusCode, statusDescription)) {
      return;
    }

    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_SUCCESS,
      payload: {
        url: authenticationUrl,
        code: statusCode,
        description: statusDescription,
        provider: 'UNAS',
        streamId: streamId
      }
    });
  } catch (error) {
    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_FAILURE,
      payload: error.response?.data || {}
    });
  }
};

const authenticateImgStream = streamId => async dispatch => {
  try {
    let clientIp = await publicIp.v4();
    const apiUrl = `/mobile/live-stream/img/${streamId}/authentication`;
    const res = await axios.get(API_GATEWAY + apiUrl, { headers: { clientIp } });
    const { authenticationUrl, statusCode, statusDescription } = res.data.authenticationResult;

    if (handleStreamAuthStatusCode(dispatch, statusCode, statusDescription)) {
      return;
    }

    fetch(authenticationUrl)
      .then(res => {
        if (res.status !== 204) {
          return res.json();
        }
        return Promise.resolve();
      })
      .then(response => {
        if (response?.hlsUrl) {
          dispatch({
            type: AUTHENTICATE_LIVE_STREAM_SUCCESS,
            payload: {
              url: response.hlsUrl,
              code: null,
              description: null,
              provider: 'IMG',
              streamId: streamId
            }
          });
        } else {
          dispatch({
            type: AUTHENTICATE_LIVE_STREAM_FAILURE,
            payload: createLiveStreamGeoBlockError()
          });
        }
      })
      .catch(() => {
        dispatch({
          type: AUTHENTICATE_LIVE_STREAM_FAILURE,
          payload: createLiveStreamGeoBlockError()
        });
      });
  } catch (error) {
    const errorData = error.response?.data;
    const errorStatusCode = getGeoBlockStatusCodeFromErrorResponse(errorData);

    if (errorStatusCode != null && errorStatusCode < 0) {
      dispatch({
        type: AUTHENTICATE_LIVE_STREAM_FAILURE,
        payload: createLiveStreamAuthFailurePayload(
          errorStatusCode,
          errorData?.authenticationResult?.statusDescription
          ?? errorData?.error?.message
          ?? errorData?.message
        )
      });
    } else {
      dispatch({
        type: AUTHENTICATE_LIVE_STREAM_FAILURE,
        payload: errorData || {}
      });
    }
  }
};

const authenticateInfrontStream = streamId => async dispatch => {
  try {
    let clientIp = await publicIp.v4();
    const apiUrl = `/mobile/live-stream/infront/${streamId}/authentication`;
    const res = await axios.get(API_GATEWAY + apiUrl, { headers: { clientIp } });
    const { authenticationUrl, statusCode, statusDescription } = res.data.authenticationResult;

    if (handleStreamAuthStatusCode(dispatch, statusCode, statusDescription)) {
      return;
    }

    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_SUCCESS,
      payload: {
        url: authenticationUrl,
        code: statusCode,
        description: statusDescription,
        provider: 'INFRONT',
        streamId: streamId
      }
    });
  } catch (error) {
    const errorData = error.response?.data;
    const errorStatusCode = getGeoBlockStatusCodeFromErrorResponse(errorData);

    if (errorStatusCode != null && errorStatusCode < 0) {
      dispatch({
        type: AUTHENTICATE_LIVE_STREAM_FAILURE,
        payload: createLiveStreamAuthFailurePayload(
          errorStatusCode,
          errorData?.authenticationResult?.statusDescription
          ?? errorData?.error?.message
          ?? errorData?.message
        )
      });
    } else {
      dispatch({
        type: AUTHENTICATE_LIVE_STREAM_FAILURE,
        payload: errorData || {}
      });
    }
  }
};

const authenticatePerformStream = sbsEventId  => async (dispatch, getState ) => {
  try {
    const externalCustomerId = getState().auth?.data?.externalCustomerId;
    const apiUrl = `/mobile/live-stream/perform/authentication/${sbsEventId}/v3?externalCustomerId=${externalCustomerId}`;
    const res = await axios.get(API_GATEWAY + apiUrl);

    dispatch({
      type: AUTHENTICATE_PERFORM_LIVE_STREAM,
      payload: res.data.authenticationResult
    });

    const { authenticationUrl, performAuthenticationToken, statusCode, statusDescription } = res.data.authenticationResult;

    const options = {
      headers: {
        Authorization: 'Bearer ' + performAuthenticationToken,
        'pf-hostpage': 'https://www.bilyoner.com',
        Referer: 'https://www.bilyoner.com',
      }
    };

    if (handleStreamAuthStatusCode(dispatch, statusCode, statusDescription)) {
      return;
    }

    fetch((authenticationUrl), options)
      .then(res => {
        if (res.status !== 204) {
          return res.json();
        }
        return Promise.resolve();
      })
      .then(response => {
        const launchUrl = getPerformLaunchUrl(response);
        if (!response || response.errorCode || !launchUrl) {
          dispatch({
            type: AUTHENTICATE_LIVE_STREAM_FAILURE,
            payload: createLiveStreamGeoBlockError()
          });
        } else {
          dispatch({
            type: AUTHENTICATE_LIVE_STREAM_SUCCESS,
            payload: {
              url: launchUrl,
              provider: 'PERFORM',
              streamId: sbsEventId,
              performInfo: res.data.authenticationResult
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: AUTHENTICATE_LIVE_STREAM_FAILURE,
          payload: createLiveStreamGeoBlockError()
        });
      });
  } catch (error) {
    dispatch({
      type: AUTHENTICATE_LIVE_STREAM_FAILURE,
      payload: error.response?.data
    });
  }
};

export const getLiveStreamData = (sportId, eventId) => async dispatch => {
  try {
    dispatch({
      type: GET_LIVE_STREAM_DATA_REQUEST
    });

    const url = qs.stringifyUrl({
      url: API_GATEWAY + '/mobile/live-stream/events',
      query: { eventType: sportId },
    });

    const res = await axios.get(url);

    dispatch({
      type: GET_LIVE_STREAM_DATA_SUCCESS,
      payload: res.data
    });

    if (eventId) {
      const competitions = res.data?.competitions;
      const activeGroup = competitions.find(group => group.events.some(event => event.webLiveStreamId === eventId));
      const activeEvent = activeGroup?.events.find(event => event.webLiveStreamId === eventId);
      const activeEventType = activeEvent?.eventType;

      if (activeEvent?.webStreamStatus === 'STARTED') {
        let eventSbsOrStreamId = activeEvent.webLiveStreamId;
        if ( activeEvent.liveStreamProvider  === 'PERFORM') {
          eventSbsOrStreamId = activeEvent.sbsEventId;
        }
        dispatch(authenticateLiveStream(eventSbsOrStreamId, activeEvent.liveStreamProvider, activeEventType) );
      }
    }

  } catch (error) {
    dispatch({
      type: GET_LIVE_STREAM_DATA_FAILURE,
      payload: error.response?.data
    });
  }
};

export const getLiveStreamCouponsData = sportId => async dispatch => {
  try {
    dispatch({
      type: GET_LIVE_STREAM_COUPONS_DATA_REQUEST
    });

    const url = qs.stringifyUrl({
      url: API_GATEWAY + '/mobile/live-stream/coupon/event',
      query: { eventType: sportId },
    });

    const res = await axios.get(url);

    dispatch({
      type: GET_LIVE_STREAM_COUPONS_DATA_SUCCESS,
      payload: res.data
    });
  } catch (error) {
    dispatch({
      type: GET_LIVE_STREAM_COUPONS_DATA_FAILURE,
      payload: error.response?.data
    });
  }
};

export const getLiveStreamTabs = () => async dispatch => {
  try {
    dispatch({
      type: GET_LIVE_STREAM_TABS_REQUEST
    });

    const res = await axios.get(API_GATEWAY + '/mobile/live-stream/header/v2');
    const availableTabs = res.data?.availableTabs || [];
    const filteredTabs = availableTabs.filter(tab => tab.tabPath !== 'tjk');
    dispatch({
      type: GET_LIVE_STREAM_TABS_SUCCESS,
      payload: filteredTabs
    });

  } catch (error) {
    dispatch({
      type: GET_LIVE_STREAM_TABS_FAILURE,
      payload: error.response?.data
    });
  }
};

export const resetLiveStreamAuthenticate = (force = false) => (dispatch, getState) => {
  const error = getState().liveStream?.activeStreamInfo?.error;

  if (!force && (isLiveStreamPlayerError(error) || isLiveStreamGeoBlockError(error))) {
    return;
  }

  dispatch({ type: RESET_LIVE_STREAM_AUTHENTICATE });
};


export const setLiveStreamStart = source => (dispatch, getState) => {
  dispatch({
    type: SET_LIVE_STREAM_START,
    payload: {
      liveStreamStartTime: new Date(),
      matchCard: getState().matchCard,
      source: source,
      hasRun: true
    },
  });
};

export const setLiveStreamStop = () => (dispatch, getState) => {
  const { liveStreamStartTime } = getState().liveStream;
  const now = new Date();
  dispatch({
    type: SET_LIVE_STREAM_STOP,
    payload: {
      startTime: liveStreamStartTime,
      stopTime: now,
      totalSeconds: differenceInSeconds(now, liveStreamStartTime),
    },
  });
};

export const setTJKLiveStreamStart = channel => dispatch => {

  dispatch({
    type: SET_TJK_LIVE_STREAM_START,
    payload: {
      tjkLiveStreamStartTime: new Date(),
      channel: channel,
    },
  });
};

export const setTJKLiveStreamStop = channel => (dispatch, getState) => {
  const { tjkLiveStreamStartTime } = getState().liveStream;
  const now = new Date();

  dispatch({
    type: SET_TJK_LIVE_STREAM_STOP,
    payload: {
      totalSeconds: differenceInSeconds(now, tjkLiveStreamStartTime),
      channel: channel,
    },
  });
};

